//
// common
//////////////////////////////////////////////////////////////////////

// page load
$(function(){
	$(window).on("load", function(event) {
		$("[data-allContents]").css("display", "block");
	});
});

// anchor link
$(function(){
	var scrollSpeed = 700;

	$("[data-anchorLink]").click(function(event) {
    var $pageHeader = $(".pageHeader"),
    		href= $(this).attr("href"),
  			target = $(href),
  			position = target.offset().top + 1,
  			headerHeight = $pageHeader.outerHeight();
		
		$("html, body").animate({scrollTop:position-headerHeight}, scrollSpeed, "swing");
		$pageHeader.removeClass("active");
		event.preventDefault();
	});
});

//
// page header
//////////////////////////////////////////////////////////////////////
$(function(){
	var classActive = "js-active",
			$navigation = $("[data-pageHeader__navigation]"),
			$headerButton = $("[data-pageHeader__button]"),
			$spMenuButton = $("[data-pageHeader__spMenuButton]");

	$spMenuButton.click(function(event) {
		$(this).toggleClass(classActive);
		$(this).find("[data-pageHeader__spMenuButtonIcon]").toggleClass(classActive);

		if($(this).hasClass(classActive)) {
			$navigation.addClass(classActive);
			$headerButton.addClass(classActive);
		} else {
			$navigation.removeClass(classActive);
			$headerButton.removeClass(classActive);
		}
	});

	$("[data-anchorLink]").click(function(event) {
		$navigation.removeClass(classActive);
		$headerButton.removeClass(classActive);
		$spMenuButton.removeClass(classActive);
		$spMenuButton.find("[data-pageHeader__spMenuButtonIcon]").removeClass(classActive);
	});
});

//
// webinar
//////////////////////////////////////////////////////////////////////
$(function(){
	var $moreButton = $("[data-pastWebinar__moreButton]"),
			$closeButton = $("[data-pastWebinar__closeButton]"),
			listClassName = "pastWebinar__listItem",
			initDispItemNum = 2,
			dispItemNum = 2,
			classHidden = "js-hidden",
			windowWidth = $(window).width(),
			$contentsVisibleButton = $("[data-pastWebinar__contentsVisibleButton]"),
			$contentsVisibleButtonText = $("[data-pastWebinar__contentsVisibleButtonText]"),
			$pastWebinarList = $("[data-pastWebinar__list]"),
			activeClass = "js-active";

	if(windowWidth <= 767) {
		$("." + listClassName + ":nth-child(n + " + (initDispItemNum + 1) + ")").addClass(classHidden);
	}

	$moreButton.on("click", function() {
	  $("." + listClassName + "." + classHidden).slice(0, dispItemNum).removeClass(classHidden);

	  if ($("." + listClassName + "." + classHidden).length == 0) {
	    $moreButton.addClass(classHidden);
	    $closeButton.removeClass(classHidden);
	  } else {
	    $moreButton.removeClass(classHidden);
	    $closeButton.addClass(classHidden);
	  }
	});

	$closeButton.on("click", function() {
		var position = $(".pastWebinar").offset().top,
				headerHeight = $(".pageHeader").outerHeight();

    $moreButton.removeClass(classHidden);
    $closeButton.addClass(classHidden);
    $("." + listClassName + ":nth-child(n + " + (initDispItemNum + 1) + ")").addClass(classHidden);
    $("html, body").animate({scrollTop:position - headerHeight - 20}, 500, "swing");
	});

	$contentsVisibleButton.on("click", function() {
		$(this).toggleClass(activeClass);

		if($(this).hasClass(activeClass)) {
			$pastWebinarList.slideDown();
			$contentsVisibleButtonText.text("閉じる");
		} else {
			$pastWebinarList.slideUp();
			$contentsVisibleButtonText.text("見る");
		}
	});
});

//
// contact
//////////////////////////////////////////////////////////////////////
$(function(){
	var $checkbox = $(".contact__form input[type=checkbox]");

	$checkbox.click(function() {
		var className = $(this).attr("class"),
				targetElement = "label",
				classChecked = "js-checked";

		if($(this).prop("checked")) {
			$(this).parent(targetElement).addClass(classChecked);
		} else {
			$(this).parent(targetElement).removeClass(classChecked);
		}
	});
});

//
// wordpress
//////////////////////////////////////////////////////////////////////
$(function(){
	// テーマで付与されるclass削除
	$("body").removeClass("page");
});


$(function(){
	$("head #lightning-common-style-css").remove();
	var head = $('head');
	var headChildren = head.children();
	var childrenLength = headChildren.length;
	for(var i = 0;i < childrenLength;i++){
		var metaName = headChildren.eq(i).attr('id');
		if(metaName === 'lightning-common-style-css'){
			headChildren.eq(i).remove();
		}
	}
});
